// src/components/MensalidadesPagas.js
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import './MensalidadesPagas.css';

function MensalidadesPagas() {
  const navigate = useNavigate();
  const [mensalidades, setMensalidades] = useState([]);
  const [dataInicial, setDataInicial] = useState('');
  const [dataFinal, setDataFinal] = useState('');
  const [error, setError] = useState(null);

  // Função para buscar as mensalidades pagas
  const fetchMensalidadesPagas = async () => {
    setError(null);

    let query = supabase
      .from('mensalidades')
      .select('*, alunos(nome, matricula)')
      .eq('status', 'Pago') // Filtra apenas mensalidades pagas
      .not('data_pagamento', 'is', null); // Garante que data_pagamento não seja nula

    // Aplica o filtro de intervalo de datas, se fornecido
    if (dataInicial) {
      query = query.gte('data_pagamento', dataInicial);
    }
    if (dataFinal) {
      query = query.lte('data_pagamento', dataFinal);
    }

    // Ordena por data_pagamento (mais recente primeiro)
    query = query.order('data_pagamento', { ascending: false });

    const { data, error } = await query;

    if (error) {
      console.error('Erro ao buscar mensalidades pagas:', error);
      setError('Erro ao carregar mensalidades: ' + error.message);
      return;
    }

    setMensalidades(data);
  };

  // Busca as mensalidades pagas ao carregar a tela e quando as datas mudarem
  useEffect(() => {
    fetchMensalidadesPagas();
  }, [dataInicial, dataFinal]); // Adiciona dataInicial e dataFinal como dependências

  // Atualiza a lista ao aplicar o filtro
  const handleFiltrar = (e) => {
    e.preventDefault();
    fetchMensalidadesPagas();
  };

  return (
    <div className="mensalidades-pagas-container">
      <h1>Mensalidades Pagas</h1>
      {error && <p className="error-message">{error}</p>}

      {/* Formulário de filtro por data */}
      <form onSubmit={handleFiltrar} className="filtro-form">
        <label>Data Inicial:</label>
        <input
          type="date"
          value={dataInicial}
          onChange={(e) => setDataInicial(e.target.value)}
        />
        <label>Data Final:</label>
        <input
          type="date"
          value={dataFinal}
          onChange={(e) => setDataFinal(e.target.value)}
        />
        <button type="submit">Filtrar</button>
      </form>

      {/* Lista de mensalidades pagas */}
      {mensalidades.length === 0 ? (
        <p>Nenhuma mensalidade paga encontrada.</p>
      ) : (
        <ul className="mensalidades-lista">
          {mensalidades.map((mensalidade) => (
            <li key={mensalidade.id} className="mensalidade-item">
              <div className="mensalidade-info">
                <span>{mensalidade.alunos.nome}</span> - Matrícula: {mensalidade.alunos.matricula}
                <br />
                Mês: {mensalidade.mes_referencia} - Status: {mensalidade.status}
                <br />
                Data de Pagamento: {new Date(mensalidade.data_pagamento).toLocaleDateString('pt-BR')}
              </div>
            </li>
          ))}
        </ul>
      )}

      <button onClick={() => navigate('/home')}>Voltar</button>
    </div>
  );
}

export default MensalidadesPagas;